export enum BitfESwitchType {
  CHECKBOX = 'CHECKBOX',
  SWITCH = 'SWITCH',
}
